import React from 'react'
import { IconClick, IconEdit, IconFileAnalytics } from '@tabler/icons-react'
import SectionTitle from './shared/SectionTitle'
import PremiumCard from './shared/PremiumCard'

export default function ProcessSection() {
  const steps = [
    {
      number: 1,
      icon: IconEdit,
      title: '录入关键信息',
      description: '在优查查后台填入必备信息（如姓名、证件号、联系方式等），或通过已有系统发起查询',
    },
    {
      number: 2,
      icon: IconClick,
      title: '一键发起查询',
      description: '点击「生成风险报告」，系统自动完成数据查询与分析，无需人工再去逐一查网站、翻资料、做表格',
    },
    {
      number: 3,
      icon: IconFileAnalytics,
      title: '查看报告并做出决定',
      description: '几秒钟内生成风险报告，重点信息一目了然。报告可导出归档，为未来复查或纠纷处理留存依据',
    },
  ]

  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-orange-200 to-transparent"></div>

      <div className="max-w-6xl mx-auto px-6 lg:px-12 relative z-10">
        <SectionTitle
          title="不会风控也能用 · 3 步完成一次风险评估"
          subtitle="优查查的设计初衷，就是让「不开会、不培训」，日常操作人员也能直接上手。"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <PremiumCard className="p-8 text-center h-full" gradient>
                <div className="absolute -top-6 left-1/2 -translate-x-1/2">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-white text-xl font-bold shadow-lg shadow-orange-500/30">
                    {step.number}
                  </div>
                </div>

                <div className="mt-8 mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100">
                    <step.icon size={32} className="text-orange-600" />
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>

                <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
              </PremiumCard>

              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 z-20">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-orange-300 to-orange-200"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
